import { render, staticRenderFns } from "./EmotionsChart.vue?vue&type=template&id=2b7b0a46&scoped=true&"
import script from "./EmotionsChart.vue?vue&type=script&lang=js&"
export * from "./EmotionsChart.vue?vue&type=script&lang=js&"
import style0 from "./EmotionsChart.vue?vue&type=style&index=0&id=2b7b0a46&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b7b0a46",
  null
  
)

export default component.exports